import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import { SOCIALS } from "@/lib/api";
import { DiscordIcon, TikTokIcon } from "@/components/icons";

const ICONS = { Instagram: Instagram, YouTube: Youtube, TikTok: TikTokIcon, Discord: DiscordIcon };

export const Footer = () => {
  return (
    <footer className="border-t border-[#2A2A2A] py-14 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-8">
        <div>
          <p className="font-anton text-xl neon-text">AIN'T DEAD YET</p>
          <p className="font-jet text-[10px] tracking-[0.25em] text-[#52525B] mt-2">
            IF YOU AIN'T DEAD YET, YOU AIN'T DONE YET
          </p>
        </div>
        <div className="flex gap-5">
          {SOCIALS.map((s) => {
            const Icon = ICONS[s.name];
            return (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${s.name.toLowerCase()}`}
                aria-label={s.name}
                className="text-[#A1A1AA] hover:text-[#39FF14] transition-colors"
              >
                <Icon size={20} />
              </a>
            );
          })}
        </div>
        <p className="font-jet text-[10px] text-[#52525B]">
          © {new Date().getFullYear()} aintdeadyet.de{" "}
          <Link to="/admin" data-testid="footer-admin-link" className="text-[#1A1A1A] hover:text-[#39FF14] transition-colors">
            [admin]
          </Link>
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-8 pt-6 border-t border-[#1A1A1A]">
        <nav
          data-testid="footer-legal-links"
          className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-jet text-[11px] tracking-[0.15em] uppercase"
        >
          <Link to="/impressum" className="text-[#A1A1AA] hover:text-[#39FF14] transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="text-[#A1A1AA] hover:text-[#39FF14] transition-colors">Datenschutzerklärung</Link>
          <Link to="/agb" className="text-[#A1A1AA] hover:text-[#39FF14] transition-colors">AGB</Link>
          <Link to="/widerruf" className="text-[#A1A1AA] hover:text-[#39FF14] transition-colors">Widerrufsbelehrung</Link>
        </nav>
      </div>
    </footer>
  );
};
